// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  maintenanceMode: false,
  country: 'es-CL',
  flag: '/assets/countries/CL.svg',
  logo: '/assets/newlogo.svg',
  DECIMAL: false,
  SEPARADOR_MONEDA: ".",
  currency: 'CLP',
  decimals: 0,
  taxes: 0.19,
  oauth: {
    logInUri: 'https://oauth.apprecio.cl/oauth/login?apiKey=6018558069292283&appId=891212511416&userId=&userInfo=',
    //logInUri: 'https://oauth.apprecio.cl/oauth/login?apiKey=6018558069292283&appId=892312613442&userId=&userInfo=',
    logOutUri: 'https://oauth.apprecio.cl/oauth/logout?apiKey=6018558069292283&appId=891212511416&userId=&userInfo=',
    //logOutUri: 'https://oauth.apprecio.cl/oauth/logout?apiKey=6018558069292283&appId=892312613442&userId=&userInfo=',
  },
  adminApiUri: 'https://api-mkp-admin-zv4qzvv7sa-uc.a.run.app/core',
  //adminApiUri: 'http://localhost:3450/core',
  mainApiUri: 'https://api-mkp-seller-zv4qzvv7sa-uc.a.run.app/core',
  //mainApiUri: 'http://localhost:3100/core',
  endpointApiUri: 'https://api-mkp-seller-zv4qzvv7sa-uc.a.run.app',
  //endpointApiUri: 'http://localhost:3100',
  loadFilesApiUri: 'https://api-mkp-carga-productos-zv4qzvv7sa-uc.a.run.app',
  //loadFilesApiUri: 'http://localhost:5200',
  locationApiUri: 'https://api-mkp-ubicacion-zv4qzvv7sa-uc.a.run.app/core',
  multivendeApiUri: 'https://api-mkp-multivende-zv4qzvv7sa-uc.a.run.app/core',
  //multivendeApiUri: 'http://localhost:3500/core',
  //multivendePollingUri: 'http://localhost:3500/polling',
  multivendePollingUri: 'https://api-mkp-multivende-zv4qzvv7sa-uc.a.run.app/polling',
  //multivendeLogUri: "https://us-central1-desarrollo-276221.cloudfunctions.net/marketplace-multivende",
  notificationApiUri: 'https://api-mkp-notificacion-zv4qzvv7sa-uc.a.run.app/core',
  //campaignsApiUri: 'http://localhost:2900/core',
  campaignsApiUri: 'https://api-mkp-campaign-zv4qzvv7sa-uc.a.run.app/core',
  recaptchaKey: '6LftdpYlAAAAAP7ynYBt5xUmkMdfs4dSqcgQEoIb',
  labels: {
    geoLevel1: 'Región',
    geoLevel2: 'Ciudad',
    geoLevel3: 'Comuna',
    houseNumber: 'Nº Casa / Departamento',
    streetName: 'Dirección',
    streetNumber: '#',
    idName: 'RUT',
  },
  statuses: {
    order: [
      'Por Aprobar',
      'En Preparación',
      'En Ruta',
      'Entregado',
      'Cancelado',
      'Devolución',
    ],
    request: ['Pendiente', 'Aprobado', 'Rechazado'],
    product: ['Imagenes pendientes', 'Borrador', 'Para eliminar', 'Con errores', 'Pendiente', 'Aprobado', 'Rechazado'],
    //TODO: cambiar forma de visualizar estados a mapa para no perder el sentido de los estados negativos
  },
  templates: {
    inventory:
      'https://cdn.dcanje.com/marketplace/templates/apprecio-marketplace-products-template.xlsx',
    stock:
      'https://cdn.dcanje.com/marketplace/templates/apprecio-marketplace-stock-template.xlsx',
    prices:
      'https://cdn.dcanje.com/marketplace/templates/apprecio-marketplace-prices-template.xlsx',
    images:
      'https://cdn.dcanje.com/marketplace/templates/apprecio-marketplace-images-template.xlsx',
    categories:
      'https://cdn.dcanje.com/marketplace/templates/apprecio-marketplace-products-categories-template-chile.xlsx',
    categoriesList:
      'https://cdn.dcanje.com/marketplace/templates/apprecio-marketplace-categories-template.xlsx',
    shipping_prices:
      'https://cdn.dcanje.com/marketplace/templates/apprecio-marketplace-shipping_prices-template.xlsx'
  },
  integrations: {
    multivende: 'https://app.multivende.com/apps/authorize?response_type=code&client_id=865733553218&redirect_uri=asd&scope=manage:all'
  },
  charts: {
    chartsUri: "https://charts.mongodb.com/charts-dcanje-chile-qoqlm",
    productsProjectId: "49bdb659-08e7-4ea3-b2b0-98581270853b"
  },
  workerImagesUrl: 'https://worker.apprecio.cl/?image='
};
